// extracted by mini-css-extract-plugin
export default {"container":"style_container__Ssyu0","header":"style_header__bY18n","contentContainer":"style_contentContainer__PMc4K"};